/* eslint-disable camelcase */
import { locationDeploymentDetailsHtml } from './location_deployment_details'

if (!window.locationPopupTemplates) {
  window.locationPopupTemplates = {}
}

const deploymentDetailsHtml = (location) => locationDeploymentDetailsHtml(location, { variant: 'popup' })

window.locationPopupTemplates.legacy = (location, assetsCount) => {
  const { name, tvid } = location
  return `
    <div>
      <h6>${name}</h6>
      <div class="mt-1 p2">Legacy Location</div>
      ${tvid
? `
        <div class="flex w-full justify-between items-center text-xs my-2">
          <span>TVID: ${tvid}</span>
        </div>`
: ''}
      ${deploymentDetailsHtml(location)}
    </div>
  `
}

window.locationPopupTemplates.static = (location, assetsCount) => {
  const { id, name, tvid, humanized_category, state, state_tag } = location
  return `
    <div>
      <h6>${name}</h6>
      <div class="flex justify-between items-center mt-1 p2">
        <span>${humanized_category || 'Static Shelter'} ${assetsCount === 0 ? '' : `(${assetsCount})`}</span>
        <span class="ml-3 tag ${state_tag || ''}-tag">${state}</span>
      </div>
      <div class="flex w-full justify-between items-center text-xs my-2">
        ${tvid ? `<span>TVID: ${tvid}</span>` : ''}
        <span><a class="hover:underline text-primary" href="/location_management/locations/${id}">Visit Location</a></span>
      </div>
      ${deploymentDetailsHtml(location)}
    </div>
  `
}

window.locationPopupTemplates.digital = (location, assetsCount) => {
  const { id, name, tvid, humanized_category, state, state_tag } = location
  return `
    <div>
      <h6>${name}</h6>
      <div class="flex justify-between items-center mt-1 p2">
        <span>${humanized_category || 'Digital Shelter'} ${assetsCount === 0 ? '' : `(${assetsCount})`}</span>
        <span class="ml-3 tag ${state_tag || ''}-tag">${state}</span>
      </div>
      <div class="flex w-full justify-between items-center text-xs my-2">
        ${tvid ? `<span>TVID: ${tvid}</span>` : ''}
        <span><a class="hover:underline text-primary" href="/location_management/locations/${id}">Visit Location</a></span>
      </div>
      ${deploymentDetailsHtml(location)}
    </div>
  `
}

window.locationPopupTemplates.urban_panel = (location, assetsCount) => {
  const { id, name, tvid, humanized_category, state, state_tag } = location
  return `
    <div>
      <h6>${name}</h6>
      <div class="flex justify-between items-center mt-1 p2">
        <span>${humanized_category || 'Urban Panel'} ${assetsCount === 0 ? '' : `(${assetsCount})`}</span>
        <span class="ml-3 tag ${state_tag || ''}-tag">${state}</span>
      </div>
      <div class="flex w-full justify-between items-center text-xs my-2">
        ${tvid ? `<span>TVID: ${tvid}</span>` : ''}
        <span><a class="hover:underline text-primary" href="/location_management/locations/${id}">Visit Location</a></span>
      </div>
      ${deploymentDetailsHtml(location)}
    </div>
  `
}

window.locationPopupTemplates.icon = (location, assetsCount) => {
  const { id, name, tvid, humanized_category, state, state_tag } = location
  return `
    <div>
      <h6>${name}</h6>
      <div class="flex justify-between items-center mt-1 p2">
        <span>${humanized_category || 'Icon'} ${assetsCount === 0 ? '' : `(${assetsCount})`}</span>
        <span class="ml-3 tag ${state_tag || ''}-tag">${state}</span>
      </div>
      <div class="flex w-full justify-between items-center text-xs my-2">
        ${tvid ? `<span>TVID: ${tvid}</span>` : ''}
        <span><a class="hover:underline text-primary" href="/location_management/locations/${id}">Visit Location</a></span>
      </div>
      ${deploymentDetailsHtml(location)}
    </div>
  `
}

window.locationPopupTemplates.combo_shelter = (location, assetsCount) => {
  const { id, name, tvid, humanized_category, state, state_tag, shelter_statuses } = location || {}

  let shelterStatusesArray = []
  if (shelter_statuses) {
    if (typeof shelter_statuses === 'string') {
      try {
        shelterStatusesArray = JSON.parse(shelter_statuses)
      } catch (e) {
        console.warn('Failed to parse shelter_statuses:', e)
      }
    } else if (Array.isArray(shelter_statuses)) {
      shelterStatusesArray = shelter_statuses
    }
  }

  const shelterStatusesHtml = shelterStatusesArray && shelterStatusesArray.length > 0
    ? shelterStatusesArray.map(shelter => {
        const assetType = shelter?.asset_type || shelter?.assetType || 'Unknown'
        const shelterState = shelter?.state || 'Unknown'
        const shelterStateTag = shelter?.state_tag || shelter?.stateTag || ''
        return `
          <div class="flex justify-between items-center text-xs my-1">
            <span>${assetType}:</span>
            <span class="tag ${shelterStateTag}-tag ml-2">${shelterState}</span>
          </div>
        `
      }).join('')
    : ''

  return `
    <div>
      <h6>${name || 'Unknown Location'}</h6>
      <div class="flex justify-between items-center mt-1 p2">
        <span>${humanized_category || 'Combo Shelter'} ${assetsCount === 0 ? '' : `(${assetsCount || 0})`}</span>
        ${state ? `<span class="ml-3 tag ${state_tag || ''}-tag">${state}</span>` : ''}
      </div>
      ${shelterStatusesHtml ? `<div class="mt-2">${shelterStatusesHtml}</div>` : ''}
      <div class="flex w-full justify-between items-center text-xs my-2">
        ${tvid ? `<span>TVID: ${tvid}</span>` : ''}
        <span><a class="hover:underline text-primary" href="/location_management/locations/${id}">Visit Location</a></span>
      </div>
      ${deploymentDetailsHtml(location)}
    </div>
  `
}

window.locationPopupTemplates.future_location = (location, assetsCount) => {
  const { name, tvid } = location
  return `
    <div>
      <h6>${name}</h6>
      <div class="mt-1 p2">Future Location</div>
      ${tvid
? `
        <div class="flex w-full justify-between items-center text-xs my-2">
          <span>TVID: ${tvid}</span>
        </div>`
: ''}
      ${deploymentDetailsHtml(location)}
    </div>
  `
}

window.locationPopupTemplates.imh = (location) => {
  const { name, hub_type, show_path, pilot_2026 } = location
  const hubLabel = hub_type === 'primary' ? 'Primary Hub' : 'Satellite'
  const pilotBadge = pilot_2026 === 'true' || pilot_2026 === true
    ? '<span class="tag tag-warning-tag text-xs">2026 Pilot</span>'
    : ''

  return `
    <div>
      <h6>${name}</h6>
      <div class="flex justify-between items-center mt-1 gap-2">
        <span class="text-xs">${hubLabel}</span>
        ${pilotBadge}
      </div>
      <div class="mt-2">
        <a class="hover:underline text-primary text-sm" href="${show_path}">View details</a>
      </div>
    </div>
  `
}
